import React from 'react';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface IProps {
  text: string;
  image: string;
  color: string;
  bgColor: string;
  url?: string;
  hoverColor?: string;
  isHorizontal?: boolean;
}

const BlokMainCards: React.FC<IProps> = ({ text, image, bgColor, color, url, hoverColor, isHorizontal = false }) => {
  const t = useTranslations();

  const cardContent = isHorizontal ? (
    <div
      className={cn(
        'h-50 group relative flex flex-col items-start justify-start overflow-hidden rounded-xl pt-4',
        bgColor,
        {
          'pl-4 pr-0': text === t('home.banner.DTMtest'),
          'px-4': text !== t('home.banner.DTMtest')
        }
      )}
    >
      <div className="-bottom-55 absolute -right-40 flex items-center justify-center">
        <div
          className="h-120 w-120 duration-400 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
          style={{ backgroundColor: `${hoverColor}33` }}
        >
          <div
            className="duration-400 h-76 w-76 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
            style={{ backgroundColor: `${hoverColor}66` }}
          >
            <div
              className="h-50 w-50 duration-400 z-0 rounded-full transition-transform group-hover:scale-110"
              style={{ backgroundColor: `${hoverColor}` }}
            />
          </div>
        </div>
      </div>

      <div className="z-10 flex flex-col items-start">
        <p className={`font-bold ${color} z-10 mt-3 max-w-40 text-3xl`}>{text?.toUpperCase()}</p>
        {text === t('home.banner.DTMtest') && <div className="mt-1 rounded-md bg-blue-600 px-2 text-white">2025</div>}
      </div>

      <div className="relative flex h-full w-full items-center justify-center">
        <Image
          src={image}
          alt={text}
          width={200}
          height={200}
          title="blok-testlarni tasvirlovchi rasm"
          className={`absolute bottom-0 ${text === t('virtual_imtihon') ? '-right-10' : 'right-0'} rounded-tr-xl`}
        />
      </div>
    </div>
  ) : (
    <div
      className={cn(
        'h-82 group relative flex flex-col items-center justify-start overflow-hidden rounded-xl pt-4',
        bgColor,
        {
          'pl-4 pr-0': text === t('home.banner.DTMtest'),
          'px-4': text !== t('home.banner.DTMtest')
        }
      )}
    >
      <div className="absolute -bottom-40 flex items-center justify-center">
        <div
          className="h-102 w-102 duration-400 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
          style={{ backgroundColor: `${hoverColor}33` }}
        >
          <div
            className="duration-400 h-76 w-76 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
            style={{ backgroundColor: `${hoverColor}66` }}
          >
            <div
              className="h-50 w-50 duration-400 z-0 rounded-full transition-transform group-hover:scale-110"
              style={{ backgroundColor: `${hoverColor}` }}
            />
          </div>
        </div>
      </div>

      <div className="z-10 flex flex-col items-center  justify-center">
        <p className={`font-semibold ${color} z-10 mt-3 text-center text-xl`}>{text}</p>
        {text === t('home.banner.DTMtest') && <div className="mt-1 rounded-md bg-blue-600 px-2 text-white">2025</div>}
      </div>

      <div className="relative flex h-full w-full items-center justify-center">
        <Image
          src={image}
          alt={text}
          width={300}
          height={300}
          title="blok-testlarni tasvirlovchi rasm"
          className="absolute bottom-0 rounded-tr-xl"
        />
      </div>
    </div>
  );

  return url ? (
    <Link href={url} onClick={() => {}}>
      {cardContent}
    </Link>
  ) : (
    cardContent
  );
};

export default BlokMainCards;
